import config from '@/config';

export default {
  install(app) {
    app.config.globalProperties.$config = config;
  },
};
